import React from "react";

const Complete = () => {
    

    return(
        <div>
            <div class="text-6xl font-bold text-centr">THANKS FOR BOOKING</div>
        </div>
    );
}

export default Complete;